import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { StyledMainContainer } from './Styles';

export interface RequiredInput {
    label?: string;

    suffix?: string;
    type?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    errorLabel?: string;

    defaultValue?: string;
    helperText?: string;
}
function RequiredInput({
    suffix,
    type,
    onChange,
    placeholder,
    errorLabel,

    label,

    defaultValue,
    helperText,
}: RequiredInput) {
    return (
        <StyledMainContainer>
            <TextField
                fullWidth
                color="secondary"
                label={label}
                defaultValue={defaultValue}
                onChange={(e) => {
                    if (onChange) {
                        onChange(e.target.value);
                    }
                }}
                placeholder={placeholder}
                id={suffix ? 'required-input' : undefined}
                type={type}
                helperText={errorLabel || helperText}
                error={Boolean(errorLabel)}
            />
            {suffix && (
                <Typography variant="body1" color="text.secondary">
                    {suffix}
                </Typography>
            )}
        </StyledMainContainer>
    );
}

export default RequiredInput;
